import { entryPoint } from "../util";
import { OsDownloadPage } from "./content";

entryPoint(OsDownloadPage);
